<template>
    <div class="margin">
        <content-item-container :showWord="true">
            <div class="reward-first">
                <div class="title-box">
                    <img class="reward-title" src="../../../assets/images/postalNewCustomer/reward_content_title_3.png">
                </div>
                <div class="img-box">
                    <img class="reward-img" src="../../../assets/images/postalNewCustomer/index_reward_third.png">
                    <div class="text-box-second" @click="instructionOpen(3)"></div>
                </div>
                <div class="text-center">
                    <div class="reward-text text-second">
                        参与每日抽奖，即可获得<span>地铁乘车券、丽达茂优惠券、青碳行邮储联名头像、青碳行定制帆布袋、狮王洗手液、狮王漱口水、狮王口喷</span>等丰富奖品。
                    </div>
                    <img class="button-sign-up" @click="toLuckDraw" src="../../../assets/images/postalNewCustomer/go_luck_draw_button.png">
                </div>
            </div>
        </content-item-container>
    </div>
</template>

<script>
import contentItemContainer from './ContentItemContainer.vue'

export default {
    components: { contentItemContainer },
    data() {
        return {}
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {
        //去抽奖
        toLuckDraw() {
            this.$emit('toLuckDraw')
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
}
.reward-first {
    padding: pxvw(32) 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title-box {
        width: pxvw(625);
    }
    .img-box {
        position: relative;
        .text-box-first {
            bottom: pxvw(50);
            left: pxvw(114);
            position: absolute;
            width: pxvw(82);
            height: pxvw(20);
        }
    }
    .reward-img {
        width: pxvw(625);
        margin-top: pxvw(19);
    }
    .reward-title {
        font-size: 0;
        height: pxvw(68);
    }
    .text-center {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .reward-text {
        font-size: pxvw(26);
        width: pxvw(548);
        text-align: justify;
        color: #898989;
        line-height: pxvw(40);
        &.text-second {
            width: pxvw(570);
            margin-left: pxvw(22);
            margin-top: pxvw(20);
            font-size: pxvw(22);
        }
        span {
            color: #1db9b2;
        }
    }
    .button-sign-up {
        width: pxvw(502);
        height: pxvw(94);
        font-size: 0;
        margin-top: pxvw(14);
    }
}
</style>